import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FullLayoutComponent, SimpleLayoutComponent } from './theme-containers';
import { HomeComponent } from './madu-components/home/home.component';
import { SairComponent } from './madu-components/sair/sair.component';
import { LoginComponent } from './madu-components/login/login.component';
import { AuthGuard } from './_helpers/auth.guard.service';
import { LogComponent } from './madu-components/log/log.component';
import { UsuariosComponent } from './madu-components/usuarios/usuarios.component';
import { EtquetasMarcopoloComponent } from './madu-components/etiquetas-marcopolo/etiquetas-marcopolo.component';
import { EtquetasMascarelloComponent } from './madu-components/etiquetas-mascarello/etiquetas-mascarello.component';


const routes: Routes = [ 
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent, 
        data: { title: 'Bem Vindo'},
        canActivate: [AuthGuard]
      },     
      {        
        path: 'etiquetas-marcopolo',
        component: EtquetasMarcopoloComponent,  
        data: { title: 'Etiquetas Marcopolo', claim: { nome: 'EtiquetasMarcopolo', valor: 'Full' }},
        canActivate: [AuthGuard]
      },      {        
        path: 'etiquetas-mascarello',
        component: EtquetasMascarelloComponent,  
        data: { title: 'Etiquetas Mascarello', claim: { nome: 'EtiquetasMarcopolo', valor: 'Full' }},
        canActivate: [AuthGuard]
      },
      {        
        path: 'log',
        component: LogComponent, 
        data: { title: 'Log', claim: { nome: 'Log', valor: 'Full' }},
        canActivate: [AuthGuard]
      },      
      {        
        path: 'gerusuarios',
        component: UsuariosComponent,  
        data: { title: 'Ger. Usuários', claim: { nome: 'Usuarios', valor: 'Full' }},
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'usuarios',
    component: SimpleLayoutComponent,
    children: [
      {
        path: 'sair',
        component: SairComponent
      },
      {
        path: 'login',
        component: LoginComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
